import React, { memo, useCallback, useState } from 'react';
import { Route, Routes } from 'react-router-dom';

import { RouteOnMount } from 'utils/routes';
import EmailEditor from './marketing/EmailEditor';
import InitialSetup from './marketing/InitialSetup';
import MarketingCampaigns from './marketing';
import Subscribers from './marketing/Subscribers';
import CampaignDetails from './marketing/CampaignDetails';

const MarketingCampaignsContainer = memo(() => {
    const [isSubscribersOpen, setIsSubscribersOpen] = useState(false);

    const handleOpenSubscribers = useCallback(() => {
        setIsSubscribersOpen(true);
    }, []);

    const handleCloseSubscribers = useCallback(() => {
        setIsSubscribersOpen(false);
    }, []);

    return (
        <>
            <Routes>
                <Route path="/" element={<RouteOnMount title="page_title_marketing_campaigns" />} />
                <Route
                    path="/email-editor"
                    element={<RouteOnMount title="page_title_email_editor" />}
                />
                <Route
                    path="/initial-setup"
                    element={<RouteOnMount title="page_title_initial_setup" onMount={() => {}} />}
                />
                <Route
                    path="/new"
                    element={<RouteOnMount title="page_title_initial_setup" onMount={() => {}} />}
                />
            </Routes>
            <Routes>
                <Route
                    path="/"
                    element={<MarketingCampaigns onManageSubscribers={handleOpenSubscribers} />}
                />
                <Route path="/email-editor" element={<EmailEditor />} />
                <Route
                    path="/initial-setup"
                    element={<InitialSetup onManageSubscribers={handleOpenSubscribers} />}
                />
                <Route path="/new" element={<CampaignDetails />} />
            </Routes>
            {isSubscribersOpen && <Subscribers onClose={handleCloseSubscribers} />}
        </>
    );
});

export default MarketingCampaignsContainer;
